import { messengerStore } from '..'

export function setCurrentChatRoomId (chatRoomId?: number) {
  messengerStore.unreadCounts.setCurrentChatRoomId(chatRoomId)
}